import { render, staticRenderFns } from "./uploadFalha.vue?vue&type=template&id=4cbcc10d"
import script from "./uploadFalha.vue?vue&type=script&lang=js"
export * from "./uploadFalha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports